/**
 * Extract a user-safe trade error from an API/mutation failure.
 * Never surface infrastructure / config dump messages in the UI.
 */
export function getTradeErrorMessage(
  error: unknown,
  fallback: string
): string {
  const apiError = getApiErrorString(error);
  if (apiError && !looksLikeInternalError(apiError)) {
    return apiError;
  }

  if (
    error instanceof Error &&
    error.message &&
    !looksLikeInternalError(error.message) &&
    !isGenericHttpError(error.message)
  ) {
    return error.message;
  }

  return fallback;
}

function readErrorField(value: unknown): string | null {
  if (!value || typeof value !== "object") return null;
  const record = value as { error?: unknown; data?: { error?: unknown } };
  if (typeof record.error === "string" && record.error.trim()) {
    return record.error.trim();
  }
  if (typeof record.data?.error === "string" && record.data.error.trim()) {
    return record.data.error.trim();
  }
  return null;
}

function getApiErrorString(error: unknown): string | null {
  if (!error || typeof error !== "object") return null;
  const response = (error as { response?: unknown }).response;
  return readErrorField(response);
}

function looksLikeInternalError(message: string): boolean {
  return /rabbitmq|amqp:\/\/|RABBITMQ_|correlationId|ECONNREFUSED|ENOTFOUND|ENOENT|stack trace|at\s+\S+\s+\(|set [A-Z_]{3,}/i.test(
    message
  );
}

function isGenericHttpError(message: string): boolean {
  return /^Request failed with status code \d+$/i.test(message.trim());
}
